import React from 'react';
import Icon from '../../../components/AppIcon';

const AttendanceStatsBanner = ({ overview }) => {
  const stats = [
    {
      title: 'Total Workforce',
      value: overview?.total_employees || 0,
      subtext: 'Active employees',
      icon: 'Users',
      color: 'text-blue-500 bg-blue-500/10 border-blue-500/20'
    },
    {
      title: 'Avg Attendance Rate',
      value: `${overview?.avg_attendance_rate || 0}%`,
      subtext: 'Monthly compliance',
      icon: 'TrendingUp',
      color: 'text-emerald-500 bg-emerald-500/10 border-emerald-500/20'
    },
    {
      title: 'Days Present',
      value: overview?.total_present || 0,
      subtext: 'Cumulative present days',
      icon: 'UserCheck',
      color: 'text-green-500 bg-green-500/10 border-green-500/20'
    },
    {
      title: 'Late Arrivals',
      value: overview?.total_late || 0,
      subtext: 'Punches after threshold',
      icon: 'Clock',
      color: 'text-amber-500 bg-amber-500/10 border-amber-500/20'
    },
    {
      title: 'Days Absent',
      value: overview?.total_absent || 0,
      subtext: 'Unexcused absences',
      icon: 'UserX',
      color: 'text-rose-500 bg-rose-500/10 border-rose-500/20'
    },
    {
      title: 'Overtime Hours',
      value: `${overview?.total_overtime_hours || 0} hrs`,
      subtext: 'Extra hours recorded',
      icon: 'Zap',
      color: 'text-purple-500 bg-purple-500/10 border-purple-500/20'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {stats.map((stat, idx) => (
        <div key={idx} className="bg-card border border-border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-medium text-muted-foreground">{stat.title}</span>
            <div className={`p-2 rounded-md border ${stat.color}`}>
              <Icon name={stat.icon} size={16} />
            </div>
          </div>
          <div className="text-xl font-bold text-foreground mb-1">{stat.value}</div>
          <div className="text-[11px] text-muted-foreground">{stat.subtext}</div>
        </div>
      ))}
    </div>
  );
};

export default AttendanceStatsBanner;
